import { render, staticRenderFns } from "./BasePriceBadges.vue?vue&type=template&id=1d57037a&scoped=true&"
import script from "./BasePriceBadges.vue?vue&type=script&lang=js&"
export * from "./BasePriceBadges.vue?vue&type=script&lang=js&"
import style0 from "./BasePriceBadges.vue?vue&type=style&index=0&id=1d57037a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57037a",
  null
  
)

export default component.exports